import React, { useState,useEffect } from 'react';
import Menu from "../Menu";
import Header from '../Header';
import Footer from '../Footer';
import { Table, Tag, Space, Tabs, Badge, Form, Select, Input, DatePicker } from 'antd';
import { Config } from '../../config/config';
import { ApiGateWay } from '../../ApiGateWay/ApiGateWay';
import { useSelector,useDispatch } from 'react-redux';
import moment from "moment";
import dayjs from 'dayjs';
import {Button} from 'antd';
import Modal from 'antd/lib/modal/Modal';
import Cookie from 'js-cookie';
import Spinner from '../../UIComponents/Spinner/Spinner';
import MessageBox from '../../UIComponents/MessageBox/MessageBox';
import { doGetWorkOrderInfo, loadTicketHistory, reScheduleWorkRequest, WorkOrderList, PostSelectedData, loadallWorkRequestInforeact, loadallWorkRequestInfofilterreact, clearWorkOrderDetails } from './actions/workOrderService';
import { useNavigate, useLocation } from 'react-router';
import { ClearData, DownloadWorkRequestReports } from '../PMP/actions/pmpService';
import ViewQuotation from '../Quotation/ViewQuotation';
import LZString from 'lz-string';

const { Option } = Select;
const { TabPane } = Tabs;
const { TextArea } = Input;

const WorkOrderStore = () =>{
    const config = JSON.parse(Config);
    const apiInterface= config['api1'];
    const jsonData = Cookie.get('currentUser');
    let decompressedData = LZString.decompressFromBase64(jsonData);
    decompressedData = decompressedData =='\x00\x00\x00'?jsonData:decompressedData;
    const user = JSON.parse(decompressedData);
    let userID = user['userId']
    const title = 'Work Order Store'
    const PendingFromVendorTableColumns = [
      {
        title: 'Action',
        dataIndex: 'action',
        key: 'action',
        render: (text, record) => {
          return (
            <Space size="middle">
              <div className="table-icons">
                <i className="fa fa-eye orange" aria-hidden="true" onClick={_doNavToAddStore}></i>
              </div>
            </Space>
          )
        }

      },
      {
        title: "Request ID",
        dataIndex: "work_request_id",
        key: "Request ID"

      },
      {
        title: "Store Name",
        dataIndex: "store_name",
        key: "Store Name"

      },
      {
        title: "Asset Name",
        dataIndex: "asset_name",
        key: "asset_name"
  
      },
      {
        title: "Scheduled Date & Time",
        dataIndex: "created_on",
        key: "created_on"
      },
      {
        title: "Status",
        dataIndex: "work_request_status_desc",
        key: "work_request_status_desc"
      }
    ]
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const location = useLocation()
    const WorkOrderStore = useSelector(state => state.WorkOrderStore)
    const WorkOrderStoreDetails = useSelector(state => state?.WorkOrderStore?.WorkRequestInfo?.WorkOrderStoreDetails)
    const CityDropdownDetails = useSelector(state => state?.WorkOrderStore?.WorkRequestInfo?.CityDropdownDetails)
    const WorkOrderStoreData = useSelector(state => state?.WorkOrderStore?.WorkRequestInfo?.WorkOrderStoreData)
    const TicketHistory = useSelector(state => state?.WorkOrderStore?.TicketHistory)
    const StoreDetails = useSelector(state => state?.WorkOrderStore?.WorkRequestInfo?.StoreDetails)
    const WorkRequestReportData = useSelector(state=> state?.pmpList?.WorkRequestReportData?.WorkRequestReportData)
    const SubCategoryList = useSelector(state=> state?.pmpList?.WorkRequestReportData?.SubCategoryList)
    const vendorDropdownDetails = useSelector(state=> state?.WorkOrderStore?.WorkRequestInfo1?.VendorDropdownDetails)
    const [filteredVendorDropdownDetails, setFilteredVendorDropdownDetails] = useState([])
    const [vendorId, setVendorId] = useState([]);
    const [priorityId, setPriorityId] = useState([]);
    const[selectedStartDate, setSelectedStartDate] = useState("")
    const[selectedEndDate, setSelectedEndDate] = useState("")
    const [isSearched, setIsSearched] = useState(false);
    const [isViewQuation, setIsViewQuation] = useState(false);
    const [reportTableData, setReportTableData] = useState([])
    const [filteredStoreDetails, setFilteredStoreDetails] = useState([])
    const [reportSubId,setReportSubId] = useState(null);
    const [TabDetails, setTabDetails] = useState([])
    const [storeId, setStoreId] = useState([]);
    const [cityIds, setCityIds] = useState([]);
    const [modalOpen, setmodalOpen] = useState(false)
    const [message, setMessage] = useState('')
    const [loading, setLoading] = useState(false)
    const [PendingForConfirmationByVendor, setPendingForConfirmationByVendor] = useState(false)
    const [AssignedToTech, setAssignedToTech] = useState(false)
    const [UnderQuotation, setUnderQuotation] = useState(false)
    const [TechIncomplete, setTechIncomplete] = useState(false)
    const [TechCompleted,setTechCompleted] = useState(false)
    const [RejectedByVendor, setRejectedByVendor] = useState(false)
    const [PendingForConfirmationByStore, setPendingForConfirmationByStore] = useState(false)
    const [WorkHistory, setWorkHistory] = useState(false)
    const [WorkClosed, setWorkClosed] = useState(false)
    const [isRescheduleByStore, setIsRescheduleByStore] = useState(false)
    const [isAcceptedByVendor, setIsAcceptedByVendor] = useState(false)
    const [PendingForConfirmationByVendorReject, setPendingForConfirmationByVendorReject] = useState(false)
    const [PendingForConfirmationByVendorAccept, setPendingForConfirmationByVendorAccept] = useState(false)
    const [PendingForConfirmationByVendorModal, setPendingForConfirmationByVendorModal] = useState(false)
    const [PendingFromVendorTableData, setPendingFromVendorTableData] = useState([])
    const [WorkInProgressTableData, setWorkInProgressTableData] = useState([])
    const [selectedData, setSelectedData] = useState([])
    const [isWorkRejectedByStore, setIsWorkRejectedByStore] = useState(false);
    const [key, setKey] = useState('1')
    const [reportData,setReportData] =useState({
      startDate:null,
      endDate:null,
      storeId:null
    })
    const [isReportGenerator, setIsReportGenerator] = useState(false)
    const [isModalVisible,setIsModalVisible] = useState(false)
    const [reScheduleData, setReScheduleData] = useState({
      fedid : userID,
      workrequestid :selectedData?.work_request_id,
      workrequest_type : 1,
      work_request_status : selectedData?.work_request_status,
      // newworkrequeststartdate :moment().format("YYYY-MM-DD hh:mm:ss"),
      newworkrequeststartdate :dayjs().format("YYYY-MM-DD hh:mm:ss"),
      work_request_comments :'',
      technician :"0",
    })
    const [isSubmit, setIsSubmit] = useState(false)

    // useEffect(() => {
    //   let isMounted = true;
    //   if((WorkOrderStoreDetails)!=undefined){
    //     if(WorkOrderStoreDetails.length!=0){
    //       const data = StausbasedData(WorkOrderStoreDetails[0].work_request_status_desc);
    //       const  PendingFromVendor = WorkOrderStoreData?.filter(item=>item.store_id == data[0]?.store_id && item.search_filter === data[0]?.search_filter)
    //       setPendingFromVendorTableData(PendingFromVendor)
    //       console.log(PendingFromVendor,'workInprogr')
    //     }
    //     if(typeof(StoreDetails) != 'undefined'){
    //         // var allFilteredData= WorkOrderStoreDetails?.filter(ele=> ele.store_id == StoreDetails[0]?.store_id)
    //         // setTabDetails(allFilteredData)
    //         if(typeof(location.state)=='undefined'){
    //           console.log(location.state,'location.state')
    //           // setStoreId(StoreDetails[0]?.store_id)
    //           // handleSearch(StoreDetails[0]?.store_id)
    //         }
    //         // else{
    //         //   console.log(location.state,'location.state')
    //         //   setStoreId(location.state.selectedStoreId)
    //         //   handleSearch(location.state.selectedStoreId)
    //         // }
    //     }
    //   }
    // return () => {
    //   isMounted = false;
    // };
    // }, [WorkOrderStoreDetails, StoreDetails,location])
    useEffect(()=>{
      setReportTableData(WorkRequestReportData)
    },[WorkRequestReportData])
    useEffect(() => {
      // let isMounted = true;
      _doGetWorkOrderStoreList()
      dispatch(doGetWorkOrderInfo())
      dispatch(loadallWorkRequestInforeact())
      return () => {
        dispatch(clearWorkOrderDetails());
      };
    }, [])
    const _doNavToAddStore = () =>{}

    const handleStoreId = (value) =>{
      let filteredVendorData = value.flatMap(item=> vendorDropdownDetails.filter(vendor=> vendor.store_id == item));
      console.log(filteredVendorData, 'filteredVendorData')
      const uniqueStatuses = Object.values(filteredVendorData.reduce((acc, obj) => {
        const key = obj.vendor_id;
        if (!acc[key])
          acc[key] = {...obj };
        return acc;
      }, {}));
      setFilteredVendorDropdownDetails(uniqueStatuses);
      setStoreId(value)
      
    }
    const handleCityIds = (values) => {
      setCityIds(values);
      let filterArray = values.flatMap(value=>StoreDetails.filter(ele=> ele.store_city ==value));
      let storeIds;
      setFilteredStoreDetails(filterArray);
      storeIds = filterArray.flatMap(ele=> storeId.filter(ele1=>ele1 == ele.store_id));
      setStoreId(storeIds);
    }
    const _doGetWorkOrderStoreList =() =>{
      setLoading(true)
      setmodalOpen(false)
      setMessage("")
    }
    
    const loadTicket = (id) =>{
      dispatch(loadTicketHistory(id))
    }
    const _doNavToQuotation = (pageUrl) => {
      setIsViewQuation(true);
      // if (pageUrl === 'Add') {
      //   // navigate("/AddQuotation");
      //   navigate({
      //     pathname: '/AddQuotation',
      //     state: { fromAddress:'/WorkOrderStore',selectedId:storeId, selectedCityIds:cityIds }
      // });
      // } else {
      //   // navigate("/ViewQuotation");
      //   navigate({
      //     pathname: '/ViewQuotation',
      //     state: { fromAddress:'/WorkOrderStore',selectedId:storeId, selectedCityIds:cityIds }
      // });
      // }
    };
    
    // Open modal based on table row selection
    const _doGetRowData = (item) => {
      // console.log(item, 'Clicked row item');
      _doCloseModal('CloseAll')
      setSelectedData(item);
      dispatch(PostSelectedData(item))
      if (item.work_request_status_desc === 'Pending from Vendor') {
        setPendingForConfirmationByVendor(true)
      }
      else if (item.work_request_status_desc === 'Accepted by Vendor') {
        setAssignedToTech(true)
      }//correct
      else if (item.work_request_status_desc === 'Under Quotation') {
        setUnderQuotation(true)
      }
      else if (item.work_request_status_desc === 'Technician Incomplete') {
        setTechIncomplete(true)
      }//correct
      else if (item.work_request_status_desc === 'Technician Completed') {
        setTechCompleted(true)
      }//correct
      else if (item.work_request_status_desc === 'Rejected By Vendor') {
        setRejectedByVendor(true);
      }
      else if (item.work_request_status_desc === 'Rescheduled by Store') {
        setIsRescheduleByStore(true);
      }//correct
      // else if (item.work_request_status_desc === 'Accepted by Vendor') {
      //   setIsAcceptedByVendor(true);
      // }//correct
      else if (item.work_request_status_desc === 'Pending for confirmation by Store') {
        setPendingForConfirmationByStore(true)
      }
      else if (item.work_request_status_desc=== 'Closed') {
        setWorkClosed(true)
      }
      else if (item.work_request_status_desc === 'Work Rejected by Store') {
        setIsWorkRejectedByStore(true)
      }
    }
  
    const _doCloseModal = (state) => {
      if (state == "PendingconfirmationfromVendor") {
        setPendingForConfirmationByVendor(false)
        setWorkHistory(false)
      }
      else if (state == "AssignedToTech") {
        setAssignedToTech(false)
        setWorkHistory(false)
      }
      else if (state == "UnderQuotation") {
        setUnderQuotation(false);
        setWorkHistory(false)
      }
      else if (state == "TechInComplete") {
        setTechIncomplete(false)
        // setTechCompleted(false)
        setWorkHistory(false)
      }
      else if (state == "TechCompleted") {
        // setTechIncomplete(false)
        setTechCompleted(false)
        setWorkHistory(false)
      }
      else if (state == "RejectedByVendor") {
        setRejectedByVendor(false);
        setWorkHistory(false)
      }
      else if(state=="RescheduleByStore"){
        setIsRescheduleByStore(false);
        setWorkHistory(false);
      }
      else if(state=="AcceptedByVendor"){
        setIsAcceptedByVendor(false);
        setWorkHistory(false);
      }
      else if (state == "PendingForConfirmationByStore") {
        setPendingForConfirmationByStore(false);
        setWorkHistory(false);
      }
      else if (state == "Closed") {
        setWorkClosed(false)
        setWorkHistory(false)
      }
      else if (state == "WorkRejectedByStore") {
        setWorkHistory(false)
        setIsWorkRejectedByStore(false);
      }
      else if(state ==="CloseAll"){
        setPendingForConfirmationByVendor(false)
        setAssignedToTech(false)
        setUnderQuotation(false);
        setTechIncomplete(false)
        setTechCompleted(false)
        setRejectedByVendor(false);
        setIsRescheduleByStore(false);
        setIsAcceptedByVendor(false);
        setWorkClosed(false)
        setWorkHistory(false)
        setPendingForConfirmationByStore(false)
        setIsWorkRejectedByStore(false);
      }
    };
  
    const _doVendorReject = (e) => {
      console.log('Helloo', e);
      e.stopPropagation();
      setPendingForConfirmationByVendorReject(true)
      //_doClosePendingConfirmModal();
      // ! Call REJECTED API here
    }
  
    const _doVendorAccept = () => {
      setPendingForConfirmationByVendorAccept(true)
    }
  
    const  _doPrevAction = (element) => {
      if (element === 'AcceptBackBtn') {
        setPendingForConfirmationByVendorAccept(false)
      } else if (element === 'RejectBackBtn') {
        setPendingForConfirmationByVendorReject(false)
        setWorkHistory(false)
      }
    }
  
    const _doVendorAccepted = () => {
      _doClosePendingConfirmModal()
      // ! Call ACCEPTED API here
    }
  
    const _doClosePendingConfirmModal = () => {
      setPendingForConfirmationByVendorModal(false)
      setPendingForConfirmationByVendorAccept(false)
      setPendingForConfirmationByVendorReject(false)
      setWorkHistory(false)
    }
  
    const _doToogleRemarks = (curentState) => {
      if (curentState === 'show') {
        setWorkHistory(true)
      } else {
        setWorkHistory(false)
      }
    }
    const StausbasedData = (status) =>{
      const data =WorkOrderStoreDetails?.filter(item=> item.work_request_status_desc === status)
      return data;
    }
    const handleData = (data,tabDetails=[])=>{
      
      if(data){
        setKey(data?.work_request_status_desc)
        if(Array.isArray(storeId)){
          const filteredList = storeId.flatMap((item) => {
            return WorkOrderStoreData.filter((obj) => obj.store_id === item && obj.search_filter ==data.search_filter);
          });
          const filteredList1 = cityIds.flatMap((item)=>{
            return filteredList.filter((obj)=>obj.store_city == item);
          });
          setPendingFromVendorTableData(cityIds.length>0 ? filteredList1 : filteredList);
          handleTabsCount(tabDetails);
          return;
        }
        const  PendingFromVendorTableData = WorkOrderStoreData?.filter(item=> item.store_id == data.store_id && item.search_filter ==data.search_filter)
      // console.log(PendingFromVendorTableData,'pendingfromvendortabledata')
        setPendingFromVendorTableData(PendingFromVendorTableData);
      }
      else{
        setPendingFromVendorTableData([]);
      }
    }
    const handleTabsCount = (tabDetails) => {
      if(cityIds.length>0){
        var updateTabDetails = JSON.parse(JSON.stringify(tabDetails));
        for(let i=0;i<tabDetails.length;i++){

          let info =  storeId.flatMap((item) => {
              return WorkOrderStoreData.filter((obj) => obj.store_id === item && obj.search_filter ==tabDetails[i].search_filter);
            });
            let info1 = cityIds.flatMap(item=>{
              return info.filter((obj)=> obj.store_city == item);
            })
            if(info1.length>0)
            updateTabDetails[i].count = info1.length;
        }
        setTabDetails(updateTabDetails)
      }
    }
    const handleWorkInPrograss = (data)=>{
      const WorkInProgress = [
        "Rescheduled by Store",
        "Under Quotation",
        "Assigned to Technician",
        "Technician Incomplete"
      ]
      let workInProgressData = []
      for(let i =0;i<WorkInProgress.length;i++){
      const  WorkInProgressTableData = WorkOrderStoreData?.filter(item=> item.store_id == data.store_id && item.work_request_status_desc === WorkInProgress[i]).map(data=>workInProgressData.push(data))
      }
      // const  WorkInProgressTableData = WorkOrderStoreData?.filter(item=> item.store_id == data.store_id && item.work_request_status_desc === "Rescheduled by Store")
      // console.log(workInProgressData,'WorkInProgressTableData')
      console.log(workInProgressData,'data work in progress')
      setWorkInProgressTableData(workInProgressData);
    }

    const handleReschedule = () =>{
      setIsSubmit(true);
      if (reScheduleData.work_request_comments == '') return
      else if (reScheduleData.newworkrequeststartdate == '') return;
      reScheduleData.workrequestid =Number(selectedData?.work_request_id);
      reScheduleData.work_request_status = Number(selectedData?.work_request_status);
      reScheduleData.newworkrequeststartdate = reScheduleData.newworkrequeststartdate.endsWith(' pm') ?reScheduleData.newworkrequeststartdate.replace(' pm',''):reScheduleData.newworkrequeststartdate.replace(' am','')
      console.log(reScheduleData,'reshceduleData');
      setIsSubmit(false);
      dispatch(reScheduleWorkRequest(reScheduleData));
      _doCloseModal('PendingconfirmationfromVendor');
    }
    const handleSearch = (value) =>{
      debugger
      if(Array.isArray(value)){
        const filteredList = value.flatMap((item) => {
          return WorkOrderStoreDetails.filter((obj) => obj.store_id === item);
        });
        const uniqueStatuses = Object.values(filteredList.reduce((acc, obj) => {
          const key = obj.work_request_status_desc;
          if (acc[key]) {
            acc[key].count += obj.count;
          } else {
            acc[key] = {...obj };
          }
          return acc;
        }, {}));
        // const uniqueArray = Array.from(new Set(filteredList.map(obj => obj.work_request_status_desc))).map(name => {
        //   return filteredList.find(obj => obj.work_request_status_desc === name);
        // });
        setTabDetails(uniqueStatuses);
        handleData(uniqueStatuses.length>0?uniqueStatuses[0]:[],uniqueStatuses)
        return;
      }
      let data = WorkOrderStoreDetails?.filter(ele=>ele.store_id == value)
      // console.log(data,'data')
      setTabDetails(data)
      handleData(data.length>0?data[0]:[],data)
    }
    const handleSearch1 = () =>{
      setIsSearched(true);
      if(selectedStartDate =="" ||selectedEndDate=="" ){
        // alert("Please select startDate and EndDate");
        return;
      }
      setIsSearched(false);
      const uniqueVendorDetails = Object.values(vendorDropdownDetails.reduce((acc, obj) => {
        const key = obj.vendor_id;
        if (!acc[key])
          acc[key] = {...obj };
        return acc;
      }, {}));
      let vendorids = vendorId.map(ele=> Number(ele));
      let allOrVendorIds = vendorId=="" || vendorId.length==0 ? filteredVendorDropdownDetails.length>0 ?filteredVendorDropdownDetails.map(ele=> Number(ele.vendor_id)): uniqueVendorDetails.map(ele=> Number(ele.vendor_id)):vendorId.map(ele=> Number(ele))
      let allOrStoreIds = storeId=="" || storeId.length==0 ?filteredStoreDetails.length>0 ? filteredStoreDetails.map(ele=> ele.store_id):StoreDetails.map(ele=> ele.store_id):storeId
      let allOrPriority = priorityId=="" || priorityId.length==0 ? ["High","Medium","Low"]:priorityId
      let payload = {
        "storeidlist": allOrStoreIds,
        "vendoridlist" : allOrVendorIds,
        "priorityList" : allOrPriority,
        "startdate" : dayjs(selectedStartDate).format("YYYY-MM-DD"),
        "enddate" :  dayjs(selectedEndDate).format("YYYY-MM-DD")
      }
      dispatch(loadallWorkRequestInfofilterreact(payload));
    }
    // after search we are getting first tab information by default based on WorkOrderSToreDetails
    useEffect(()=>{
      if(!WorkOrderStoreDetails){
        return;
      }
      const uniqueStatuses = Object.values(WorkOrderStoreDetails?.reduce((acc, obj) => {
        const key = obj.work_request_status_desc;
        if (acc[key]) {
          acc[key].count += obj.count;
        } else {
          acc[key] = {...obj };
        }
        return acc;
      }, {}));
      setTabDetails(uniqueStatuses);
      handleData1(uniqueStatuses.length>0?uniqueStatuses[0]:[],uniqueStatuses)
    },[WorkOrderStoreDetails])
    const handleData1 = (tab, tabDetails=[]) => {
      setKey(tab?.work_request_status_desc)
      const  filteredPendingVendorTableData = WorkOrderStoreData?.filter(item=> item.search_filter ==tab.search_filter)
      setPendingFromVendorTableData(filteredPendingVendorTableData);
      // handleTabsCount(tabDetails);
    }
    const downloadReport = ()=>{
      console.log(selectedData,'record')
      // window.location.href = apiInterface+`/downloadimages?Image_id=${selectedData?.pdf_path}`
      window.location.href =`${apiInterface}/downloadfiles?Image_id=${selectedData?.pdf_path}&token_id=${Cookie.get('token')}`
    }
    const handleSearchReport = ()=>{
      setIsSubmit(true)
      if(reportData.storeId==null) return
      else if(reportData.startDate == null|| reportData.startDate =='') return
      else if(reportData.endDate == null || reportData.endDate == '') return
      console.log(reportData,'reportData')
      const jsonData = {
        start_date:reportData.startDate,
        end_date:reportData.endDate,
        store_id:reportData.storeId,
      }
      dispatch(DownloadWorkRequestReports(jsonData))
    }
    const handleReportTableData = () =>{
      if(reportSubId==null || typeof(reportSubId) =="undefined"){
        setReportTableData(WorkRequestReportData)
      }
      else{
        let data = [];
        let fetchedData = WorkRequestReportData?.filter(ele=>ele.sub_category_id == reportSubId).map(e=>data.push(e))
        setReportTableData(data)
      }
    }
    const handleReportGenerator = () => {
      setIsReportGenerator(true)
      setIsModalVisible(true)
    }
  const handleCloseReportGenerator = () => {
    setIsSubmit(false)
    setReportData({...reportData,storeId:null,startDate:null,endDate:null})
    setReportSubId(null)
    dispatch(ClearData())
    setIsModalVisible(false);
    setIsReportGenerator(false);
  };
  const handleDownloadReport = (data) => {
    // window.location.href = `${apiInterface}/downloadimages?Image_id=${data.pdf_path}`
    if(data.pdf_path!=""  && data.pdf_path.includes('.pdf')==true){
      // window.location.href = `${apiInterface}/downloadimages?Image_id=${data.pdf_path}`
      window.location.href = `${apiInterface}/downloadfiles?Image_id=${data.pdf_path}&token_id=${Cookie.get('token')}`
  }
  }
  const  disabledDate = (current) => {
    // let date = moment().add(1,'days')
    // return current && current > moment(date,'DD-MM-YYYY').startOf('day');
    let date = dayjs().add(1, 'day').startOf('day');
  return current && current > date;
}
const CloseViewQuotation = () => {
  _doCloseModal('CloseAll')
  setIsViewQuation(false);
}
const handleVendorSelection = (value) => {
  // if(value=="All"){
  //   let allVendorIds = filteredVendorDropdownDetails.map(ele=> (ele.vendor_id));
  //   allVendorIds.unshift("All")
  //   setVendorId(allVendorIds);
  //   return;
  // }
  setVendorId(value);
}
const handlePrioritySelection = (value) => {
  
  // let isContainsAll = value.some(ele=> ele== "All")
  // if(isContainsAll && value.length!=4){
  //   let all = ['All', 'High', "Medium", "Low"];
  //   setPriorityId(all);
  //   return;
  // }
  setPriorityId(value);
}
      return (
        <>
        {isViewQuation==false ? 
          <div>
            {WorkOrderStore.modalOpen ? (
                  <MessageBox
                  message={WorkOrderStore.message}
            // signout={"false"}
                  onClose={()=>{
                      dispatch(doGetWorkOrderInfo())
                      dispatch(WorkOrderList(true))
                  }}
            
                  />

                  ) : null}
    
            <div className="wrapper">
              <Header title={title} />
              <Menu />
              <div className='content-wrapper'>
                {WorkOrderStore?.loading ? (
                  <Spinner />
                ) : (
                  <div>
                    <section className='content'>
                      <div className="m-panel mt-10">
                        <div className="m-panel__body p10">
                          <div className="row">
                          <div className="col-md-3">
                              <div className='form-group select_h150'>
                                <label htmlFor='exampleInput'>Select City</label>
                                <Select className="form-control"
                                mode="multiple"
                                  showSearch
                                  name="exampleInput"
                                  onChange={(value)=>handleCityIds(value)}
                                  placeholder="-- Please Select --"
                                  optionFilterProp="children"
                                  value={cityIds}
                                  filterOption={(input, option) =>
                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                  }
                                > {
                                  CityDropdownDetails?.map((item =>
                                      <Option key={item.store_city} value={item.store_city}>{item.city_name}</Option>
                                    ))
                                  }
                                </Select>
                              </div>
                            </div>
                            <div className="col-md-3">
                              <div className='form-group select_h150'>
                                <label htmlFor='exampleInput'>Select Store</label>
                                <Select className="form-control"
                                mode="multiple"
                                  showSearch
                                  name="exampleInput"
                                  onChange={(value)=>handleStoreId(value)}
                                  placeholder="-- Please Select --"
                                  optionFilterProp="children"
                                  value={storeId}
                                  filterOption={(input, option) =>
                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                  }
                                > {
                                  filteredStoreDetails?.map((item =>
                                      <Option key={item.store_id} value={item.store_id}>{item.store_name}</Option>
                                    ))
                                  }
                                </Select>
                              </div>
                            </div>

                            <div className="col-md-3">
                                <div className='form-group select_h150'>
                                  <label htmlFor='exampleInput'>Select Vendor</label>
                                  <Select className="form-control"
                                  mode="multiple"
                                    showSearch
                                    name="exampleInput"
                                    onChange={(value)=>handleVendorSelection(value)}
                                    placeholder="-- Please Select --"
                                    optionFilterProp="children"
                                    value={vendorId}
                                    filterOption={(input, option) =>
                                      option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                  > 
                                  {/* <Option  value="All">All</Option> */}
                                  {
                                    filteredVendorDropdownDetails?.map(((item,index) =>
                                        <Option key={index} value={item.vendor_id}>{item.vendor_company_name}</Option>
                                      ))
                                    }
                                  </Select>
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className='form-group select_h150'>
                                  <label htmlFor='exampleInput'>Select Priority</label>
                                  <Select className="form-control"
                                  mode="multiple"
                                    showSearch
                                    name="exampleInput"
                                    onChange={(value)=>handlePrioritySelection(value)}
                                    placeholder="-- Please Select --"
                                    optionFilterProp="children"
                                    value={priorityId}
                                    filterOption={(input, option) =>
                                      option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                  > 
                                    {/* <Option  value="All">All</Option> */}
                                    <Option value ="High">High</Option>
                                    <Option value ="Medium">Medium</Option>
                                    <Option value ="Low">Low</Option>
                                  </Select>
                                </div>
                            </div>
                            
                            
    
                          </div>
                          <div className='row'>
                            
                            <div className="col-md-3">
                                <div className='form-group select_h150'>
                                  <label htmlFor='exampleInput'>Select Start Date</label>
                                  <DatePicker  
                                  value={selectedStartDate}
                                  onChange={(date)=> setSelectedStartDate(date)} 
                                                placeholder="Select Date & Time" format="YYYY-MM-DD" className="form-control"
                                            />
                                  {isSearched== true && selectedStartDate =="" && <p className='text-danger'>Please select Start Date</p>}
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className='form-group select_h150'>
                                  <label htmlFor='exampleInput'>Select End Date</label>
                                  <DatePicker  
                                  value={selectedEndDate}
                                  onChange={(date)=>setSelectedEndDate(date)}
                                                placeholder="Select Date & Time" format="YYYY-MM-DD" className="form-control"
                                            />
                                            {isSearched== true && selectedEndDate =="" && <p className='text-danger'>Please select End Date</p>}
                                </div>
                            </div>
                            <div className="col-md-1 btn-no-lbl">
                              {/* <button type='submit' className='btn btn-secondary btn-icon deca-btn-yellow'  onClick={()=>handleSearch(storeId)}>
                                <i className="fa fa-search"></i>
                              </button> */}
                              <button type='submit' className='btn btn-secondary btn-icon deca-btn-yellow'  onClick={()=>handleSearch1()}>
                                <i className="fa fa-search"></i>
                              </button>
                            </div>

                            <div className="col-md-1 btn-no-lbl">
                              <button type='submit' className='btn btn-secondary btn-icon deca-btn-yellow'  onClick={handleReportGenerator}>
                                View Report
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="m-panel mt-10">
                        <div className='m-panel_body p10 custom-tabs'>
                        <Tabs defaultActiveKey="1" activeKey={key}>
                            {TabDetails?.map((item,index)=>{
                              return(
                                <TabPane
                                  tab={
                                    <p key={index} style={{color:item.work_request_status_colour}} onClick={()=>handleData1(item,TabDetails)}>
                                      <span style={{color:'black'}}>{item.count}</span> {item.work_request_status_desc}
                                    </p> 
                                  }
                                  key={item.work_request_status_desc}
                                >
                                  <div className="m-table__main">
                                    <div className="m-table__responsive medium-width">
                                      <Table
                                        filterSearch="true"
                                        onRow={(record, recordIndex) => ({
                                          onClick: event => { { _doGetRowData(record, recordIndex) } }
                                        })}
                                        columns={PendingFromVendorTableColumns}
                                        dataSource={PendingFromVendorTableData}/>
                                    </div>
                                  </div>
                                </TabPane>
                              )
                            })}
                        </Tabs>
                            {/* <Table className="Mahesh" dataSource={PendingFromVendorTableData} columns={PendingFromVendorTableColumns} />; */}
                        </div>
                      </div>
                    </section>
                  </div>
                )}
              </div>
              <Footer />
              {PendingForConfirmationByVendor === true ?
                <div className="m-modal">
                  <div className="m-modal__container">
                    <div className="m-modal__header">
                      <h5 className="m-modal__title"> Pending for confirmation from Vendor </h5>
                      <span className="m-modal__close" onClick={() => _doCloseModal('PendingconfirmationfromVendor')}>
                        <i className="fa fa-close"></i>
                      </span>
                    </div>
                    <div className="m-modal__body">
                      <div className="row">
                        <div className="col-md-12">
                          <div className="">
                            <div className="c-pic__img">
                            {selectedData.work_request_image !='' && <img src={apiInterface+`/downloadimages?Image_id=${selectedData.work_request_image}`} className="" alt="work_request_image" />}
                            {selectedData.work_request_image1 !='' && <img src={apiInterface+`/downloadimages?Image_id=${selectedData.work_request_image1}`} className="" alt="work_request_image1" />}
                            </div>
                          </div>
                        </div>
                        {WorkHistory == true ?
                          <React.Fragment>
                            <div className="col-md-12">
                              <button className="btn-link btn-link--bold" type="button" onClick={() => (_doToogleRemarks('hide'),loadTicket(selectedData.work_request_id))}>Go Back</button>
                            </div>
                            <div className="col-md-12">
                            <ul className="remarks__list">
                                {TicketHistory?.map((item,index)=>{
                                    return(
                                      <li className="remarks__item">
                                        <div className="remarks__userdetails">
                                          <h5>{item.from}</h5>
                                          <h5>{item.work_request_start_date}</h5>
                                        </div>
                                        <div className="remarks__reason">
                                          <h5>Comments</h5>
                                          <p>{item.work_request_comments}</p>
                                        </div>
                                        <div className="remarks__userdetails">
                                          <p>Reschedule Date</p>
                                          <p>{item.work_request_reschedule_date}</p>
                                        </div>
                                      </li>
                                    )
                                })}
                            </ul>
                            </div>
                          </React.Fragment>
                          :
                          <React.Fragment>
                            <div className="col-md-12 status_remarks">
                              {selectedData?.pdf_path.includes('.pdf') &&<span className="text-primary" style={{cursor:'pointer'}} onClick={()=>downloadReport()}>Download Report</span>}
                              <button className="btn-link btn-link--bold" type="button" onClick={() => (_doToogleRemarks('show'),loadTicket(selectedData.work_request_id))}>Remarks</button>
                            </div>
                            <div className="col-md-12">
                              <div className="form-group">
                                <label htmlFor='exampleInput'>Asset Name</label>
                                <input type="text" className="form-control" disabled value={selectedData?.asset_name} />
                                {/* <span>{selectedData?.asset_name}</span> */}
                              </div>
                            </div>
                            <div className="col-md-12">
                              <div className="form-group">
                                <label htmlFor='exampleInput'>Priority</label>
                                <input type="text" className="form-control" disabled value={selectedData?.work_request_priority} />
                                {/* <span>{selectedData?.work_request_priority}</span> */}
                              </div>
                            </div>
                            <div className="col-md-12">
                              <div className="form-group">
                                <label htmlFor='exampleInput'>Vendor Name</label>
                                <input type="text" className="form-control" disabled value={selectedData?.vendor_company_name} />
                                {/* <span>{selectedData?.vendor_company_name}</span> */}
                              </div>
                            </div>
                            <div className="col-md-12">
                              <div className="form-group">
                                <label htmlFor='exampleInput'>Issue Description</label>
                                <textarea type="text" rows="3" className="form-control" value={selectedData?.work_request_description} disabled></textarea>
                                {/* <span>{selectedData?.work_request_description}</span> */}
                              </div>
                            </div>
                            <div className="col-md-12">
                              <div className="form-group">
                                <label htmlFor='exampleInput'>Date & Time</label>
                                <input type="text" className="form-control" disabled value={selectedData?.created_on} />
                                {/* <span>{selectedData?.work_request_start_date}</span> */}
                              </div>
                            </div>
                            {
                              (selectedData?.work_request_status ==0 ||selectedData?.work_request_status ==1) && 
                              <>
                              {/* <div className="col-md-12">
                                <div className="form-group">
                                <label>Select Reschedule Date</label>
                                <DatePicker  showTime={{ format: 'hh:mm' }} use12Hours
                                    placeholder="Select Date & Time" default format="YYYY-MM-DD hh:mm:ss a" className="form-control"
                                    onChange={(date, dateString) => setReScheduleData({...reScheduleData, newworkrequeststartdate:dateString})}
                                    // defaultValue={showingData?.pmpstartdate ? moment(showingData?.pmpstartdate, "YYYY-MM-DD hh:mm:ss" ):''}
                                />
                                {reScheduleData.newworkrequeststartdate =='' && isSubmit == true && <span style={{color:'red'}}>please Select Reschedule Date </span>}
                                </div>
                              </div> */}
                              {/* <div className="col-md-12">
                                <div className="form-group">
                                  <textarea type="text" rows="3" className="form-control" onChange={(e)=> setReScheduleData({...reScheduleData, work_request_comments:e.target.value})} ></textarea>
                                  {reScheduleData.work_request_comments =='' && isSubmit == true && <span style={{color:'red'}}>please Select Reschedule Date </span>}
                                </div>
                              </div> */}

                              {/* <div className="col-md-12 text-center">
                                <div className="m-page__button  top-space text-center">
                                  <button type='button' className='btn btn-secondary deca-btn-yellow' onClick={()=>handleReschedule()}>ReSchedule</button>
                                </div>
                              </div>   */}
                              </>
                            }
                            <div>
                              
                            </div>
                          </React.Fragment>
                        }
                      </div>
                    </div>
                  </div>
                </div>
                : false}
              {AssignedToTech === true ?
                <div className="m-modal">
                  <div className="m-modal__container">
                    <div className="m-modal__header">
                      <h5 className="m-modal__title"> Assigned To Technician </h5>
                      <span className="m-modal__close" onClick={() => _doCloseModal('AssignedToTech')}>
                        <i className="fa fa-close"></i>
                      </span>
                    </div>
                    <div className="m-modal__body">
                      <div className="row">
                        <div className="col-md-12">
                          <div className="">
                            <div className="c-pic__img">
                              {/* <img src={apiInterface+`/displaystoreimages?info_row_id=${selectedData.asset_id}&&type=2`} className="" alt="asset-img" /> */}
                              {selectedData.work_request_image !='' && <img src={apiInterface+`/downloadimages?Image_id=${selectedData.work_request_image}`} className="" alt="work_request_image" />}
                            {selectedData.work_request_image1 !='' && <img src={apiInterface+`/downloadimages?Image_id=${selectedData.work_request_image1}`} className="" alt="work_request_image1" />}
                            </div>
                          </div>
                        </div>
                        {WorkHistory == true ?
                          <React.Fragment>
                            <div className="col-md-12">
                              <button className="btn-link btn-link--bold" type="button" onClick={() => _doToogleRemarks('hide')}>Go Back</button>
                            </div>
                            <div className="col-md-12">
                              <ul className="remarks__list">
                                {TicketHistory?.map((item,index)=>{
                                    return(
                                      <li className="remarks__item">
                                        <div className="remarks__userdetails">
                                          <h5>{item.from}</h5>
                                          <h5>{item.work_request_start_date}</h5>
                                        </div>
                                        <div className="remarks__reason">
                                          <h5>Comments</h5>
                                          <p>{item.work_request_comments}</p>
                                        </div>
                                        <div className="remarks__userdetails">
                                          <p>Reschedule Date</p>
                                          <p>{item.work_request_reschedule_date}</p>
                                        </div>
                                      </li>
                                    )
                                })}
                              </ul>
                            </div>
                          </React.Fragment>
                          :
                          <React.Fragment>
                            <div className="col-md-12 status_remarks">
                            {selectedData?.pdf_path.includes('.pdf') &&<span className="text-primary" style={{cursor:'pointer'}} onClick={()=>downloadReport()}>Download Report</span>}
                              <button className="btn-link btn-link--bold" type="button" onClick={() => (_doToogleRemarks('show'), loadTicket(selectedData.work_request_id))}>Remarks</button>
                            </div>
                            <div className="col-md-12">
                              <div className="form-group">
                                <label htmlFor='exampleInput'>Asset Name</label>
                                <input type="text" className="form-control" disabled value={selectedData.asset_name} />
                              </div>
                            </div>
                            <div className="col-md-12">
                              <div className="form-group">
                                <label htmlFor='exampleInput'>Priority</label>
                                <input type="text" className="form-control" disabled value={selectedData.work_request_priority} />
                              </div>
                            </div>
                            <div className="col-md-12">
                              <div className="form-group">
                                <label htmlFor='exampleInput'>Issue Description</label>
                                <textarea type="text" rows="3" className="form-control" value={selectedData.work_request_description} disabled></textarea>
                              </div>
                            </div>
                            <div className="col-md-12">
                              <div className="form-group">
                                <label htmlFor='exampleInput'>Scheduled Date & time</label>
                                <input type="text" className="form-control" disabled value={selectedData.submitted_date_time} />
                              </div>
                            </div>
                            <div className="col-md-12">
                              <div className="form-group">
                                <label htmlFor='exampleInput'>Name Of Techincaion</label>
                                <input type="text" className="form-control" disabled value={selectedData.technician_name}/>
                              </div>
                            </div>
                            <div className="col-md-12">
                              <div className="form-group">
                                <label htmlFor='exampleInput'>Mobile</label>
                                <input type="text" className="form-control" disabled value={selectedData.technician_number} />
                              </div>
                            </div>
                            <div className="col-md-12">
                              <div className="form-group">
                                <label htmlFor='exampleInput'>Remarks by Vendor</label>
                                <textarea type="text" rows="3" className="form-control" value={selectedData.workrequest_remarks} disabled></textarea>
                              </div>
                            </div>
                          </React.Fragment>
                        }
                      </div>
                    </div>
                  </div>
                </div>
                : false}
              {UnderQuotation === true || TechIncomplete === true ||TechCompleted==true|| PendingForConfirmationByStore === true || WorkClosed === true ?
                <div className="m-modal">
                  <div className="m-modal__container">
                    <div className="m-modal__header">
                      {TechIncomplete === true ?
                        <React.Fragment>
                          <h5 className="m-modal__title">Technician Incomplete</h5>
                          <span className="m-modal__close" onClick={() => _doCloseModal('TechInComplete')}>
                            <i className="fa fa-close"></i>
                          </span>
                        </React.Fragment> : null}
                      {TechCompleted === true ?
                        <React.Fragment>
                          <h5 className="m-modal__title">Technician Completed</h5>
                          <span className="m-modal__close" onClick={() => _doCloseModal('TechCompleted')}>
                            <i className="fa fa-close"></i>
                          </span>
                        </React.Fragment> : null}
                      {UnderQuotation === true ?
                        <React.Fragment>
                          <h5 className="m-modal__title">Under Quotation</h5>
                          <span className="m-modal__close" onClick={() => _doCloseModal('UnderQuotation')}>
                            <i className="fa fa-close"></i>
                          </span>
                        </React.Fragment> : null}
                      {PendingForConfirmationByStore === true ?
                        <React.Fragment>
                          <h5 className="m-modal__title">Pending For Confirmation By Store</h5>
                          <span className="m-modal__close" onClick={() => _doCloseModal('PendingForConfirmationByStore')}>
                            <i className="fa fa-close"></i>
                          </span>
                        </React.Fragment> : null}
                      {WorkClosed === true ?
                        <React.Fragment>
                          <h5 className="m-modal__title">Work Closed</h5>
                          <span className="m-modal__close" onClick={() => _doCloseModal('Closed')}>
                            <i className="fa fa-close"></i>
                          </span>
                        </React.Fragment> : null}
                    </div>
                    <div className="m-modal__body">
                      <div className="row">
                        <div className="col-md-12">
                          <div className="">
                            <div className="c-pic__img">
                              {/* <img src={apiInterface+`/displaystoreimages?info_row_id=${selectedData.asset_id}&&type=2`} className="" alt="asset-img" /> */}
                              {selectedData.work_request_image !='' && <img src={apiInterface+`/downloadimages?Image_id=${selectedData.work_request_image}`} className="" alt="work_request_image" />}
                            {selectedData.work_request_image1 !='' && <img src={apiInterface+`/downloadimages?Image_id=${selectedData.work_request_image1}`} className="" alt="work_request_image1" />}
                            </div>
                          </div>
                        </div>
                        {WorkHistory == true ?
                          <React.Fragment>
                            <div className="col-md-12">
                              <button className="btn-link btn-link--bold" type="button" onClick={() => _doToogleRemarks('hide')}>Go Back</button>
                            </div>
                            <div className="col-md-12">
                              <ul className="remarks__list">
                              {TicketHistory?.map((item,index)=>{
                                  return(
                                    <li className="remarks__item">
                                      <div className="remarks__userdetails">
                                        <h5>{item.from}</h5>
                                        <h5>{item.work_request_start_date}</h5>
                                      </div>
                                      <div className="remarks__reason">
                                        <h5>Comments</h5>
                                        <p>{item.work_request_comments}</p>
                                      </div>
                                      <div className="remarks__userdetails">
                                        <p>Reschedule Date</p>
                                        <p>{item.work_request_reschedule_date}</p>
                                      </div>
                                    </li>
                                  )
                                })}
                              </ul>
                            </div>
                          </React.Fragment>
                          :
                          <React.Fragment>
                            <div className="col-md-12 status_remarks">
                            {selectedData?.pdf_path.includes('.pdf') &&<span className="text-primary" style={{cursor:'pointer'}} onClick={()=>downloadReport()}>Download Report</span>}
                              <button className="btn-link btn-link--bold" type="button" onClick={() =>(_doToogleRemarks('show'),loadTicket(selectedData.work_request_id))}>Remarks</button>
                            </div>
                            <div className="col-md-12">
                              <div className="form-group">
                                <label htmlFor='exampleInput'>Asset Name</label>
                                <input type="text" className="form-control" disabled value={selectedData.asset_name} />
                              </div>
                            </div>
                            <div className="col-md-12">
                              <div className="form-group">
                                <label htmlFor='exampleInput'>Priority</label>
                                <input type="text" className="form-control" disabled value={selectedData.work_request_priority} />
                              </div>
                            </div>
                            <div className="col-md-12">
                              <div className="form-group">
                                <label htmlFor='exampleInput'>Issue Description</label>
                                <textarea type="text" rows="3" className="form-control" value={selectedData.work_request_description} disabled></textarea>
                              </div>
                            </div>
                            <div className="col-md-12">
                              <div className="form-group">
                                <label htmlFor='exampleInput'>Scheduled Date & time</label>
                                <input type="text" className="form-control" disabled value={selectedData.created_on} />
                              </div>
                            </div>
                            <div className="col-md-12">
                              <div className="form-group">
                                <label htmlFor='exampleInput'>Submitted Date & time</label>
                                <input type="text" className="form-control" disabled value={selectedData.submitted_date_time} />
                              </div>
                            </div>
                            <div className="col-md-12">
                              <div className="form-group">
                                <label htmlFor='exampleInput'>Name Of Techincaion</label>
                                <input type="text" className="form-control" disabled value={selectedData.technician_name}/>
                              </div>
                            </div>
                            <div className="col-md-12">
                              <div className="form-group">
                                <label htmlFor='exampleInput'>Mobile</label>
                                <input type="text" className="form-control" disabled value={selectedData.technician_number} />
                              </div>
                            </div>
                            <div className="col-md-12">
                              <div className="form-group">
                                <label htmlFor='exampleInput'>Signature By Technician</label>
                                <img className ='technician-img' src={apiInterface+`/downloadimages?Image_id=${selectedData.technician_signature_image}`}  alt="Signature By Technician" />
                              </div>
                            </div>
                            <div className="col-md-12">
                              <div className="form-group">
                                <label htmlFor='exampleInput'>Remarks by Technician</label>
                                <input type="text" className="form-control" disabled value={selectedData.workrequest_remarks} />
                              </div>
                            </div>
                            <div className="col-md-12">
                              <div className="form-group">
                                <label htmlFor='exampleInput'>Attached Image</label>
                                <img className ='technician-img' src={apiInterface+`/downloadimages?Image_id=${selectedData.completed_image}`} alt="Issue Image" />
                              </div>
                            </div>
                            <div className="col-md-12">
                              <div className="form-group">
                                <label htmlFor='exampleInput'>Quotation</label>
                                {/* <input type="text" className="form-control" disabled value={selectedData.quotation_required} /> */}
                                <input type="checkbox"  disabled checked={selectedData.quotation_required==0 ? false : true} style={{width:20,height:20,display:'block'}}/>
                              </div>
                            </div>
                            {UnderQuotation === true || WorkClosed === true ?
                              <div className="col-md-12 text-center">
                                <div className="m-page__button  top-space text-center">
                                  <button type='button' className='btn btn-secondary deca-btn-yellow' onClick={() => _doNavToQuotation('view')}>View Quotation</button>
                                </div>
                              </div>
                              : false}
                          </React.Fragment>
                        }
                      </div>
                    </div>
                  </div>
                </div>
                : false}
              {(RejectedByVendor|| isWorkRejectedByStore ) ?
                <div className="m-modal">
                  <div className="m-modal__container">
                    <div className="m-modal__header">
                      <h5 className="m-modal__title">
                      {
                        RejectedByVendor ? "Rejected By Vendor"
                        : isWorkRejectedByStore ? "Work Rejected By store"
                        :""
                      } 
                      </h5>
                      <span className="m-modal__close" onClick={() => 
                        RejectedByVendor ? _doCloseModal('RejectedByVendor')
                        : isWorkRejectedByStore ? _doCloseModal('WorkRejectedByStore')
                        :""}
                        >
                        <i className="fa fa-close"></i>
                      </span>
                    </div>
                    <div className="m-modal__body">
                      <div className="row">
                        <div className="col-md-12">
                          <div className="">
                            <div className="c-pic__img">
                              {/* <img src={apiInterface+`/displaystoreimages?info_row_id=${selectedData.asset_id}&&type=2`} className="" alt="asset-img" /> */}
                              {selectedData.work_request_image !='' && <img src={apiInterface+`/downloadimages?Image_id=${selectedData.work_request_image}`} className="" alt="work_request_image" />}
                            {selectedData.work_request_image1 !='' && <img src={apiInterface+`/downloadimages?Image_id=${selectedData.work_request_image1}`} className="" alt="work_request_image1" />}
                            </div>
                          </div>
                        </div>
    
                        {WorkHistory == true ?
                          <React.Fragment>
                            <div className="col-md-12">
                              <button className="btn-link btn-link--bold" type="button" onClick={() =>_doToogleRemarks('hide')}>Go Back</button>
                            </div>
                            <div className="col-md-12">
                              <ul className="remarks__list">
                              {TicketHistory?.map((item,index)=>{
                                  return(
                                    <li className="remarks__item">
                                      <div className="remarks__userdetails">
                                        <h5>{item.from}</h5>
                                        <h5>{item.work_request_start_date}</h5>
                                      </div>
                                      <div className="remarks__reason">
                                        <h5>Comments</h5>
                                        <p>{item.work_request_comments}</p>
                                      </div>
                                      <div className="remarks__userdetails">
                                        <p>Reschedule Date</p>
                                        <p>{item.work_request_reschedule_date}</p>
                                      </div>
                                    </li>
                                  )
                                })}
                              </ul>
                            </div>
                          </React.Fragment>
                          :
                          <React.Fragment>
                            <div className="col-md-12 status_remarks">
                            {selectedData?.pdf_path.includes('.pdf') &&<span className="text-primary" style={{cursor:'pointer'}} onClick={()=>downloadReport()}>Download Report</span>}
                              <button className="btn-link btn-link--bold" type="button" onClick={() =>(_doToogleRemarks('show'),loadTicket(selectedData.work_request_id))}>Remarks</button>
                            </div>
                            <div className="col-md-12">
                              <div className="form-group">
                                <label htmlFor='exampleInput'>Asset Name</label>
                                <input type="text" className="form-control" disabled value={selectedData.asset_name} />
                              </div>
                            </div>
                            <div className="col-md-12">
                              <div className="form-group">
                                <label htmlFor='exampleInput'>Priority</label>
                                <input type="text" className="form-control" disabled value={selectedData.work_request_priority} />
                              </div>
                            </div>
                            <div className="col-md-12">
                              <div className="form-group">
                                <label htmlFor='exampleInput'>Vendor Name</label>
                                <input type="text" className="form-control" disabled value={selectedData.vendor_company_name} />
                              </div>
                            </div>
                            <div className="col-md-12">
                              <div className="form-group">
                                <label htmlFor='exampleInput'>Issue Description</label>
                                <textarea type="text" rows="3" className="form-control" value={selectedData.work_request_description} disabled></textarea>
                              </div>
                            </div>
                            <div className="col-md-12">
                              <div className="form-group">
                                <label htmlFor='exampleInput'>Date & Time</label>
                                <input type="text" className="form-control" disabled value={selectedData.work_request_start_date} />
                              </div>
                            </div>
                            <div className="col-md-12">
                              <div className="form-group">
                                <label htmlFor='exampleInput'>Reason for Rejected</label>
                                <input type="text" className="form-control" disabled value={selectedData.work_request_reject_remarks} />
                              </div>
                            </div>
                            <div className="col-md-12">
                              <div className="form-group">
                                <label htmlFor='exampleInput'>Remakrs</label>
                                <input type="text" className="form-control" disabled value={selectedData.workrequest_remarks} />
                              </div>
                            </div>
                          </React.Fragment>
                        }
                      </div>
                    </div>
                  </div>
                </div>
                : false}

                {
                  isRescheduleByStore == true &&
                  <div className="m-modal">
                  <div className="m-modal__container">
                    <div className="m-modal__header">
                      <h5 className="m-modal__title"> Rescheduled by Store</h5>
                      <span className="m-modal__close" onClick={() => _doCloseModal('RescheduleByStore')}>
                        <i className="fa fa-close"></i>
                      </span>
                    </div>
                    <div className="m-modal__body">
                      <div className="row">
                        <div className="col-md-12">
                          <div className="">
                            <div className="c-pic__img">
                              {/* <img src={apiInterface+`/displaystoreimages?info_row_id=${selectedData.asset_id}&&type=2`} className="" alt="asset-img" /> */}
                              {selectedData.work_request_image !='' && <img src={apiInterface+`/downloadimages?Image_id=${selectedData.work_request_image}`} className="" alt="work_request_image" />}
                            {selectedData.work_request_image1 !='' && <img src={apiInterface+`/downloadimages?Image_id=${selectedData.work_request_image1}`} className="" alt="work_request_image1" />}
                            </div>
                          </div>
                        </div>
    
                        {WorkHistory == true ?
                          <React.Fragment>
                            <div className="col-md-12">
                              <button className="btn-link btn-link--bold" type="button" onClick={() =>_doToogleRemarks('hide')}>Go Back</button>
                            </div>
                            <div className="col-md-12">
                              <ul className="remarks__list">
                                {TicketHistory?.map((item,index)=>{
                                  return(
                                    <li className="remarks__item">
                                      <div className="remarks__userdetails">
                                        <h5>{item.from}</h5>
                                        <h5>{item.work_request_start_date}</h5>
                                      </div>
                                      <div className="remarks__reason">
                                        <h5>Comments</h5>
                                        <p>{item.work_request_comments}</p>
                                      </div>
                                      <div className="remarks__userdetails">
                                        <p>Reschedule Date</p>
                                        <p>{item.work_request_reschedule_date}</p>
                                      </div>
                                    </li>
                                  )
                                })}
                              </ul>
                            </div>
                          </React.Fragment>
                          :
                          <React.Fragment>
                            <div className="col-md-12 status_remarks">
                            {selectedData?.pdf_path.includes('.pdf') &&<span className="text-primary" style={{cursor:'pointer'}} onClick={()=>downloadReport()}>Download Report</span>}
                              <button className="btn-link btn-link--bold" type="button" onClick={() =>(_doToogleRemarks('show'),loadTicket(selectedData.work_request_id))}>History</button>
                            </div>
                            <div className="col-md-12">
                              <div className="form-group">
                                <label htmlFor='exampleInput'>Asset Name</label>
                                <input type="text" className="form-control" disabled value={selectedData.asset_name} />
                              </div>
                            </div>
                            <div className="col-md-12">
                              <div className="form-group">
                                <label htmlFor='exampleInput'>Priority</label>
                                <input type="text" className="form-control" disabled value={selectedData.work_request_priority} />
                              </div>
                            </div>
                            <div className="col-md-12">
                              <div className="form-group">
                                <label htmlFor='exampleInput'>Vendor Name</label>
                                <input type="text" className="form-control" disabled value={selectedData.vendor_company_name} />
                              </div>
                            </div>
                            <div className="col-md-12">
                              <div className="form-group">
                                <label htmlFor='exampleInput'>Issue Description</label>
                                <textarea type="text" rows="3" className="form-control" value={selectedData.work_request_description} disabled></textarea>
                              </div>
                            </div>
                            <div className="col-md-12">
                              <div className="form-group">
                                <label htmlFor='exampleInput'>Date & Time</label>
                                <input type="text" className="form-control" disabled value={selectedData.created_on && selectedData.created_on.slice(0,19)} />
                              </div>
                            </div>
                            <div className="col-md-12">
                              <div className="form-group">
                                <label htmlFor='exampleInput'>Remakrs</label>
                                <input type="text" className="form-control" disabled value={selectedData.workrequest_remarks} />
                              </div>
                            </div>
                          </React.Fragment>
                        }
                      </div>
                    </div>
                  </div>
                  </div>
                }
            </div>
            {
                  isReportGenerator === true ?
                      <Modal title="Download Report" width={1000} closeIcon open={isModalVisible}
                          footer={[
                              <Button key="back" onClick={handleCloseReportGenerator}>
                                  Cancel
                              </Button>
                          ]}>
                          <div className="row">
                          <div className="col-md-3">
                            <div className='form-group'>
                              <label htmlFor='exampleInput'>Select Store</label>
                              <Select className="form-control"
                                showSearch
                                onChange={(value)=>setReportData({...reportData,storeId:value})}
                                placeholder="-- Please Select --"
                                optionFilterProp="children"
                                // value={storeId}
                                filterOption={(input, option) =>
                                  option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }
                              > {
                                StoreDetails?.map(((item,index) =>
                                    <Option key={index} value={item.store_id}>{item.store_name}</Option>
                                  ))
                                }
                              </Select>
                              {reportData.storeId == null && isSubmit == true && <span className='text-danger'>Please Select Store</span>}
                            </div>
                          </div>
                          <div className="col-md-4">
                              <div className="form-group">
                                  <label htmlFor='exampleInput'>Start Date*</label>
                                  <DatePicker className="form-control" format={'DD-MM-YYYY'} disabledDate={disabledDate} onChange={(date, dateString) => setReportData({...reportData,startDate:dateString})}/>
                                  {(reportData.startDate == null || reportData.startDate == '') && isSubmit == true && <span className='text-danger'>Please Select Start Date</span>}
                              </div>
                          </div>
                          <div className="col-md-4">
                              <div className="form-group">
                                  <label htmlFor='exampleInput'>End Date*</label>
                                  <DatePicker className="form-control" format={'DD-MM-YYYY'} disabledDate={disabledDate} onChange={(date, dateString) => setReportData({...reportData,endDate:dateString})}/>
                                  {(reportData.endDate == null || reportData.endDate == '') && isSubmit == true && <span className='text-danger'>Please Select End Date</span>}
                              </div>
                          </div>

                          <div className="col-md-1 btn-no-lbl">
                            <button type='submit' className='btn btn-secondary btn-icon deca-btn-yellow'  onClick={()=>handleSearchReport()}>
                                <i className="fa fa-search"></i>
                            </button>
                          </div>
                          </div>
                          <div className="row">
                            <div className="col-md-3">
                                <div className='form-group'>
                                  <label htmlFor='exampleInput'>Select Subcategory</label>
                                  <Select className="form-control"
                                    showSearch
                                    onChange={(value)=>setReportSubId(value)}
                                    placeholder="-- Please Select --"
                                    optionFilterProp="children"
                                    allowClear={true}
                                    filterOption={(input, option) =>
                                      option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                  > {
                                    SubCategoryList?.map(((item,index) =>
                                        <Option key={index} value={item.sub_category_id}>{item.sub_category_name}</Option>
                                      ))
                                    }
                                  </Select>
                                </div>
                            </div>
                            <div className="col-md-1 btn-no-lbl">
                              <button type='submit' className='btn btn-secondary btn-icon deca-btn-yellow'  onClick={handleReportTableData}>
                                <i className="fa fa-search"></i>
                              </button>
                            </div>
                          </div>
                          <div className='row'>
                              <div className='col-md-12'>
                                  <div className='table'>
                                      <table className='table table-striped table-bordered'>
                                          <thead className='bg-primary'>
                                              <tr>
                                                  <th>S.No</th>
                                                  <th>Subcategory Name</th>
                                                  <th>Asset Name</th>
                                                  <th>Start Date</th>
                                                  <th>Vendor Name</th>
                                                  <th>Technician Name</th>
                                                  <th>Action</th>
                                              </tr>
                                          </thead>
                                          <tbody className='text-center'>
                                              
                                              {
                                                  reportTableData?.map((ele,index)=>{
                                                      return(
                                                          <tr key = {index}>
                                                              <td>{index+1}</td>
                                                              <td>{ele.sub_category_name}</td>
                                                              <td>{ele.asset_name}</td>
                                                              <td>{ele.work_request_start_date}</td>
                                                              <td>{ele.vendor_company_name}</td>
                                                              <td>{ele.technician_name}</td>
                                                              {/* <td onClick={()=>handleDownloadReport(ele)} style={{cursor:'pointer'}}>{ele.pdf_path.includes('.pdf')&&<i className="fa fa-download"/>}</td> */}
                                                              <td onClick={()=>handleDownloadReport(ele)} style={ele.pdf_path.includes('.pdf')? {cursor:'pointer'}:{cursor:'default'}}>{ele.pdf_path.includes('.pdf')&&<i className="fa fa-download"/>}</td>
                                                          </tr>
                                                      )
                                                  })
                                              }
                                          </tbody>
                                      </table>
                                  </div>

                              </div>
                          </div>
                      </Modal>
                      : false
              }
          </div >
        : <ViewQuotation
              selectedData = {selectedData}
              CloseViewQuotation = {CloseViewQuotation}
          />
        }
        </>
      )
    
}
export default WorkOrderStore;

